import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import io from "../assets/io.jpg";
import { FaDownload } from "react-icons/fa";
import cv from "../assets/cv.pdf"
import { Link } from "react-scroll";

function Home() {
  const handleDownloadClick = () => {
    window.open(cv, "_blank");
  };
  return (
    <div name="home" className="w-full h-screen bg-[#F3DFBF]">
      {/* Container*/}
      <div className="max-w-[1000px] mx-auto px-8 flex flex-col md:flex-row justify-center h-full items-center">
        <img
          src={io}
          alt="io"
          className="mx-auto w-48 h-48 md:mr-8 rounded-full hidden sm:hidden md:block lg:block"
        />
        <div>
          <p className="text-black text-3xl"> Ciao, sono</p>
          <h1 className="text-4xl sm:text-7xl font-bold text-[#008148] ">
            {" "}
            Nicola Saladino
          </h1>
          <p className="text-[] py-1 max-w-[780px] text-xl italic">
            Attualmente sto frequentando un corso IFTS di programmazione Java e
            tecniche per la progettazione e la gestione di database erogato
            dalla fondazione et-labora a Bergamo
          </p>
          <div className="flex flex-row items-center">
            <button className="text-black group border-2 border-[#008148] px-6 py-3 my-2 flex items-center hover:bg-[#008148] hover:text-[#fff]">
              <Link to="work" smooth={true} duration={500}>
            View Work
          </Link>
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowNarrowRight className="ml-3" />
              </span>
            </button>
            <button className="text-black group border-2 border-[#f4a261] px-6 py-3 my-2 mx-10 flex items-center hover:bg-[#f4a261] hover:text-[#000]" onClick={handleDownloadClick}>
              Download CV
              <span className="group-hover:rotate-12 duration-300">
                <FaDownload className="ml-3" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;




